export default __webpack_public_path__ + "static/media/Pistol_8.288eb89e.png";